import { ThisConnector } from '../../../api/connector'
import { BaseApiResponse } from '../../../api/shared'

export interface UnmergeAllModulesArgs {
  organizationID: string
  primaryApplicationID: string
}

export async function unmergeAllModules(
  this: ThisConnector,
  { organizationID, primaryApplicationID }: UnmergeAllModulesArgs
): Promise<BaseApiResponse> {
  return this.connector.executeDelete(
    `/${organizationID}/modules/${primaryApplicationID}/child`
  )
}
